// Функция для получения информации о браузере
export function getBrowserInfo() {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const os = getOS();
    const browser = getBrowser();
    const version = getBrowserVersion();

    return {
        userAgent,
        platform,
        os,
        browser,
        version
    };
}

function getOS() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Mac')) return 'MacOS';
    if (userAgent.includes('Windows')) return 'Windows';
    if (userAgent.includes('Linux')) return 'Linux';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('iOS')) return 'iOS';
    return 'Unknown';
}

function getBrowser() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('Chrome')) return 'Chrome';
    if (userAgent.includes('Safari')) return 'Safari';
    if (userAgent.includes('Edge')) return 'Edge';
    if (userAgent.includes('Opera')) return 'Opera';
    return 'Unknown';
}

function getBrowserVersion() {
    const userAgent = navigator.userAgent;
    const browser = getBrowser();
    
    switch (browser) {
        case 'Chrome':
            return userAgent.match(/Chrome\/([0-9.]+)/)?.[1] || 'Unknown';
        case 'Firefox':
            return userAgent.match(/Firefox\/([0-9.]+)/)?.[1] || 'Unknown';
        case 'Safari':
            return userAgent.match(/Version\/([0-9.]+)/)?.[1] || 'Unknown';
        case 'Edge':
            return userAgent.match(/Edge\/([0-9.]+)/)?.[1] || 'Unknown';
        case 'Opera':
            return userAgent.match(/Opera\/([0-9.]+)/)?.[1] || 'Unknown';
        default:
            return 'Unknown';
    }
} 